import axios from "axios";

export const state = {
    reportpersonalpayments: [],
};

export const getters = {
    reportpersonalpayments: state => state.reportpersonalpayments,
};

export const mutations = {
    setReportPersonalPayments(reportpersonalpayments, newValue) { state.reportpersonalpayments = newValue},
};

export const actions = {
    fetchReportPersonalPayments({ commit }) {
        axios.get('/reportpersonalpayments').then(res => {
            commit('setReportPersonalPayments', res.data.payments)
        })
    },
    filterReportPersonalPayments({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportpersonalpayments";
        axios.post(url, formData).then((response) => {
            commit('setReportPersonalPayments', response.data.payments)
        })
    },
};
